export const COLLECTIBLE_DATE_SORT_OPTIONS = [
    { value: 'recent', label: 'Recently added' },
    { value: 'oldest', label: 'Oldest first' },
];

export const isMostLikedSort = (value) => value === 'mostLiked';

export const normalizeDateSort = (value) => (value === 'oldest' ? 'oldest' : 'recent');

export const normalizeCollectibleSort = (value) => {
    if (value === 'oldest' || value === 'mostLiked') return value;
    return 'recent';
};

export const isValidCollectibleSort = (value) =>
    value === 'recent' || value === 'oldest' || value === 'mostLiked';

/** Prefer React sort state — it updates before the URL during toolbar clicks. */
export const resolveCollectibleRequestSort = (urlSort, sortBy) =>
    normalizeCollectibleSort(sortBy || urlSort);

export const getItemLikeCount = (item) => {
    const raw = item?.numberOfLikes ?? item?.NumberOfLikes ?? 0;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : 0;
};
